import { render, staticRenderFns } from "./chip-secondary.vue?vue&type=template&id=5f947633&scoped=true"
import script from "./chip-secondary.vue?vue&type=script&lang=js"
export * from "./chip-secondary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f947633",
  null
  
)

export default component.exports